module.exports = __webpack_public_path__ + "img/ivywayIG_QR.0df06e9c.jpg";